module.exports = __webpack_public_path__ + "img/ico-fb.5179540b.svg";